import { useState, useEffect } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import Notification, { showToast } from '../../../components/common/notification/Notification';
import Spinner from '../../../components/common/spinner/Spinner';
import RowList from '../../components/listing/RowList';
import { Row, Col } from 'react-bootstrap';
import Pagination from '../../components/pagination/Pagination';
import PromotionFilter from './PromotionFilter';
import { Link } from "react-router-dom"; 
import "../postAdmin/filter.css";
import { FiSearch, FiPlus } from "react-icons/fi";
import "../propertyNew/PropertyListComponent.css";

const PromoListComponent = ({route}) => {
  const loggedInUser = useSelector((state) => state.auth.user);
  console.log("loggedInUser in promo list", loggedInUser.user.id);
  const assetUrl = process.env.REACT_APP_ASSET_URL;

  const token = loggedInUser?.refreshToken;
  const baseUrl = process.env.REACT_APP_BASE_URL; 

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [promotions, setPromotions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [isError, setIsError] = useState(false); 
  const [searchTerm, setSearchTerm] = useState(''); 
  const [FilteredPromotions, setFilteredPromotions] = useState(promotions);

  const userType = loggedInUser?.user?.userType?.name || loggedInUser?.userType;
  const isPartner = userType === "PARTNER";

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const endpoint = isPartner ? `${baseUrl}/promotion/list/preferred` : `${baseUrl}/promotion/`;
      const payload = isPartner
        ? {
            type: "",
            state: "",
            city: "",
            keyboard_search: searchTerm || "",
            page_number: currentPage,
            page_size: 10,
            order_by: "DESC",
            is_partner: true,
          }
        : {
            page_number: currentPage,
            page_size: 20,
            order_by: "DESC",
          };

      const response = await axios.post(endpoint, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200 && (response.data.statusType === 'SUCCESS' || Array.isArray(response.data.promotions) || response.data.data)) {
        const fetchedList = response.data.promotions || response.data.data || response.data.propertyAssets || [];
        setPromotions(fetchedList); 
        setTotalPages(response.data.totalPages || response.data.total_pages || 1);
      } else {
        showToast('Failed to fetch Promotion data', { type: 'error' });
      }
    } catch (error) {
      console.error('Fetch error:', error);
      showToast('Error fetching Promotion data', { type: 'error' });
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async (itemId) => {
    try {
      const response = await axios.delete(
        `${baseUrl}/promotion/delete/${itemId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        } 
      );
      // console.log(response)
      if (response.data.statusType === 'SUCCESS') {
        setPromotions(promotions.filter((item) => item.id !== itemId));
        showToast('Promotion deleted successfully', { type: 'success' });
      } else {
        showToast(`${response.data.text}`, { type: 'error' });
      }
    } catch (error) {
      console.error('Error deleting Promotion :', error);
      showToast('Error occurred during deletion', { type: 'error' });
    }
  };

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    if (!term) {
      setFilteredPromotions([]);
      return;
    }

    const filtered = promotions.filter(promotion => {
      const fname = promotion.partner.first_name?.toLowerCase() || ''; 
      const lname = promotion.partner.last_name?.toLowerCase() || '';
      const title = promotion.project_name?.toLowerCase() || '';
      const description = promotion.project_description?.toLowerCase() || '';
      return (
        fname.includes(term) ||  
        lname.includes(term) ||
        title.includes(term) ||
        description.includes(term)
      );
    });

    setFilteredPromotions(term ? filtered : promotions);
  }; 

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };


  const applyCustomFilters = (filters) => {
    const filtered = promotions.filter((promo) => {
      const matchType = !filters.type || promo.property_type?.name === filters.type;
      const matchCity = !filters.city || promo.city_name === filters.city;
      const matchState = !filters.state || promo.state_name === filters.state;

      const matchesSearch = !searchTerm || (
        promo.partner.first_name?.toLowerCase().includes(searchTerm) ||
        promo.partner.last_name?.toLowerCase().includes(searchTerm) ||
        promo.project_name?.toLowerCase().includes(searchTerm) ||
        promo.project_description?.toLowerCase().includes(searchTerm)
      );

      return matchType && matchCity && matchState && matchesSearch;
    });

    setFilteredPromotions(filtered);
  };

  // get filtered array
  const getUnique = (array, key) => {
    return [...new Set(array.map(item => item[key]).filter(Boolean))];
  };

  const uniqueCities = getUnique(promotions, "city_name");
  const uniqueStates = getUnique(promotions, "state_name");
  const uniqueTypes = getUnique(promotions.map(p => p.property_type || {}), "name");

  // publish/unpublish toggle handler for promotions
  const handleToggleEnable = async (itemId) => {
    const current = promotions.find((p) => p.id === itemId);
    console.log("current", current);
    const newPublishStatus = !current.active;
    console.log("newPublishStatus", newPublishStatus);

    try { 
      const response = await axios.put(
        `${baseUrl}/promotion/publish/status`,
        {
          lead_id: itemId,
          is_publish: newPublishStatus,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response?.data?.statusType === "SUCCESS") {
        const updatedPromos = promotions.map((promo) =>
          promo.id === itemId ? { ...promo, active: newPublishStatus } : promo
        );

        setPromotions(updatedPromos);

        showToast(
          newPublishStatus
            ? "Promotion Enabled Successfully"
            : "Promotion Disabled Successfully",
          { type: "success" }
        );
      } else {
        showToast("Failed to update promotion status", { type: "error" });
      }
    } catch (error) {
      console.error("Error updating promotion status:", error);
      showToast("Error updating promotion status", { type: "error" });
    }
  };

  return (
    <>
      <Notification />

      <div className="algn-items-center">
        <Row className="my-2 px-3">
          <Col xs={12}>
            <div className="plc__toolbar">
              <div className="plc__search-wrap">
                <FiSearch className="plc__search-icon" size={16} />
                <input
                  className="plc__search-input"
                  type="text"
                  placeholder="Search by name, city, state, country..."
                  value={searchTerm}
                  onChange={handleSearch}
                />
                <button className="plc__search-btn" type="button">
                  Search
                </button>
              </div>

              <div className="plc__toolbar-actions">
                <PromotionFilter
                  onFilter={applyCustomFilters}
                  cities={uniqueCities}
                  states={uniqueStates}
                  types={uniqueTypes}
                />
                {(loggedInUser?.user?.userType?.name === "PARTNER" ||
                  loggedInUser?.user?.userType?.name === "ALL_HOME_DESIRE") && (
                  <Link to="/add-promotion" className="plc__add-btn">
                    <FiPlus size={16} /> Add Promotion
                  </Link>
                )}
              </div>
            </div>
          </Col>
        </Row>
      <div>
      
      </div>
        <Row className='d-flex justify-content-center'>
          <Col >
            {isLoading ? (
              <Spinner loading={true} />
            ) : (
              (() => {
                let listToRender = [];
                if (FilteredPromotions.length > 0 || searchTerm) {
                  listToRender = FilteredPromotions;
                } else {
                  listToRender = promotions;
                }
                return listToRender.map((item) => (
                  <RowList
                    key={item.id}
                    title={item.project_name}
                    creator={`${item.partner.first_name} ${item.partner.last_name}`}
                    CardImg={item?.propertyImages[0]?.image_url ? (assetUrl + item?.propertyImages[0]?.image_url) : null}
                    createOn={item.created_on}
                    item={item} 
                    route={route} 
                    handleDelete={handleDelete}
                    // handleToggleEnable={handleToggleEnable}
                    handleToggleEnable={item.partner.id === loggedInUser.user.id ? handleToggleEnable : undefined}
                    checkBox={item.active} 
                  /> 
                )); 
              })()
            )}
          </Col>
            <div className="mt-2 mb-4 d-flex justify-content-center">
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </div>
        </Row>
      </div>

      
    </>
  );
};

export default PromoListComponent;